<template>
    <div class="content-wrapper">
        <section class="hero hero--full">
            <hero-content :title="$helpers.trans('errors.404.title')">
                <p>{{ $helpers.trans('errors.404.description') }}</p>
                <a href="/" class="btn btn-primary">{{ $helpers.trans('errors.404.label') }}</a>
            </hero-content>
        </section>
    </div>
</template>
<script>
import HeroContent from '#app#/components/common/HeroElements/Content.vue'
export default {
    created() {
        this.$store.commit('setLoading', false);
    },
    components: {
        HeroContent
    }
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/errors/404.vue